"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimation = exports.eventErr = exports.polyfillErr = void 0;

var components_utils_1 = require("@conte-ltd/components-utils");

var react_1 = require("react");

exports.polyfillErr = '💡 use-web-animations: please install polyfill to use this hook. See https://github.com/wellyshen/use-web-animations##use-polyfill';

var eventErr = function eventErr(type) {
  return "\uD83D\uDCA1 use-web-animations: the browser doesn't support " + type + " event, please use \"onUpdate\" to monitor the animation's state instead. See https://github.com/wellyshen/use-web-animations#basic-usage";
};

exports.eventErr = eventErr;

function useLast(value) {
  var ref = (0, react_1.useRef)(value);
  (0, react_1.useEffect)(function () {
    ref.current = value;
  });
  return ref;
}

var useAnimation = function useAnimation(_a) {
  var _b = _a === void 0 ? {} : _a,
      refOpt = _b.ref,
      id = _b.id,
      playbackRate = _b.playbackRate,
      autoPlay = _b.autoPlay,
      keyframes = _b.keyframes,
      optionsProp = _b.options,
      onReady = _b.onReady,
      onUpdate = _b.onUpdate,
      onFinish = _b.onFinish;

  var contextRef = (0, react_1.useRef)();

  var _c = __read((0, react_1.useState)(), 2),
      playState = _c[0],
      setPlayState = _c[1];

  var hasUnmountedRef = (0, react_1.useRef)(false);
  var animRef = (0, react_1.useRef)();
  var prevPendingRef = (0, react_1.useRef)();
  var prevPlayStateRef = (0, react_1.useRef)();
  var onReadyRef = useLast(onReady);
  var onUpdateRef = useLast(onUpdate);
  var onFinishRef = useLast(onFinish);
  var refVar = (0, react_1.useRef)(null);
  var ref = refOpt || refVar;

  var options = __assign({
    fill: 'both'
  }, optionsProp);

  var getAnimation = (0, react_1.useCallback)(function () {
    return animRef.current;
  }, []);
  var getContext = (0, react_1.useCallback)(function () {
    return contextRef.current;
  }, []);
  var animate = (0, react_1.useCallback)(function (args, context) {
    if (!ref.current || !args.keyframes) {
      return;
    }

    if (!ref.current.animate) {
      console.error(exports.polyfillErr);
      return;
    }

    animRef.current = ref.current.animate(args.keyframes, args.options);
    var anim = animRef.current;
    contextRef.current = context;
    if (args.autoPlay === false) anim.pause();
    if (args.id) anim.id = args.id;
    if (args.playbackRate) anim.playbackRate = args.playbackRate;

    if (onReadyRef.current) {
      if (anim.ready) {
        anim.ready.then(function (animation) {
          var _a;

          (_a = onReadyRef.current) === null || _a === void 0 ? void 0 : _a.call(onReadyRef, {
            playState: animation.playState,
            animate: animate,
            animation: animation
          }, context);
        });
      } else {
        console.error((0, exports.eventErr)('onReady'));
      }
    }

    if (onFinishRef.current) {
      anim.onfinish = function (e) {
        var _a;

        var animation = e.target;

        if (!hasUnmountedRef.current) {
          (_a = onFinishRef.current) === null || _a === void 0 ? void 0 : _a.call(onFinishRef, {
            playState: animation.playState,
            animate: animate,
            animation: animation
          }, context);
        }
      };
    }

    prevPlayStateRef.current = undefined;
  }, [onFinishRef, onReadyRef, ref]);
  (0, components_utils_1.useDeepCompareEffect)(function () {
    if (keyframes) animate({
      id: id,
      playbackRate: playbackRate,
      autoPlay: autoPlay,
      keyframes: keyframes,
      options: options
    });
  }, [animate, autoPlay, id, playbackRate, keyframes, options]);
  (0, react_1.useEffect)(function () {
    var rafId;

    var update = function update() {
      var animation = getAnimation();
      var context = getContext();

      if (animation) {
        var pending = animation.pending,
            curPlayState = animation.playState;
        if (prevPlayStateRef.current !== curPlayState) setPlayState(curPlayState);
        if (onUpdateRef.current && (prevPendingRef.current !== pending || prevPlayStateRef.current !== curPlayState || curPlayState === 'running')) onUpdateRef.current({
          playState: curPlayState,
          animate: animate,
          animation: animation
        }, context);
        prevPendingRef.current = pending;
        prevPlayStateRef.current = curPlayState;
      }

      rafId = requestAnimationFrame(update);
    };

    rafId = requestAnimationFrame(update);
    return function () {
      var _a, _b;

      cancelAnimationFrame(rafId);
      hasUnmountedRef.current = true;
      (_a = getAnimation()) === null || _a === void 0 ? void 0 : _a.finish();
      (_b = getAnimation()) === null || _b === void 0 ? void 0 : _b.cancel();
    };
  }, [animate, getAnimation, getContext, onUpdateRef]);
  return {
    ref: ref,
    playState: playState,
    animate: animate,
    getAnimation: getAnimation,
    getContext: getContext
  };
};

exports.useAnimation = useAnimation;